import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Accordion from "@insite/mobius/Accordion/Accordion";
import DynamicDropdown from "@insite/mobius/DynamicDropdown/DynamicDropdown";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Hidden from "@insite/mobius/Hidden/Hidden";
import Tab from "@insite/mobius/Tab";
import TabGroup from "@insite/mobius/TabGroup";
import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import handlePDPTabDisplay from "@tCentro/Handlers/CENPDPCarouselTabs";
import { TabGroupState } from "@tCentro/Store/CENProductCarouselTabsReducer";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";
import React, { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: TabGroupState) => ({
    isRecentlyViewedTabVisible: state.productCarouselTabsReducer.isRecentlyViewedTabVisible,
    isRelatedProductsTabVisible: state.productCarouselTabsReducer.isRelatedProductsTabVisible,
    isComponentsTabVisible: state.productCarouselTabsReducer.isComponentsTabVisible,
    isTopSellerTabVisible: state.productCarouselTabsReducer.isTopSellerTabVisible,
    currentTab: state.productCarouselTabsReducer.currentTab,
});

const mapDispatchToProps = {
    handlePDPTabDisplay,
};

interface BCIATabularDataModel {
    fields: {
        name: string;
        type: string;
        tabName: string;
    };
}

const enum fields {
    numberOfTabs = "numberOfTabs",
    cssClass = "cssClass",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.numberOfTabs]: BCIATabularDataModel[];
        [fields.cssClass]: string;
    };
}

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface BCIATabularDataStyles {
    wrapper?: InjectableCss;
    hideTab?: InjectableCss;
    titleWeight: InjectableCss;
}
export const tabularDataStyles: BCIATabularDataStyles = {
    wrapper: {
        css: css`
            margin-bottom: 104px;
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        margin-bottom: 26px;
                    `,
                    css`
                        margin-bottom: 26px;
                    `,
                    css`
                        margin-bottom: 48px;
                    `,
                    null,
                ]);
            }}
            .tabsMobile {
                input[type^="text"] {
                    background: #f2f2f2;
                    border: 2px solid #262525;
                    border-radius: 40px;
                    margin-bottom: 19px;
                    padding: 12px 50px 12px 24px !important;
                    height: 48px;

                    + span {
                        padding: 12px 0px 12px 24px;
                    }
                }
                div[class^="OverflowWrapper"] {
                    color: ${getProp("theme.typography.p.color")};
                    font-weight: 500;
                    font-size: 14px;
                    line-height: 24px;
                    > span[class^="IconWrapper"] {
                        background: url("/userFiles/images/chevronDown.svg") no-repeat;
                        height: 42px !important;
                        background-position: center;
                        svg {
                            display: none;
                        }
                    }
                }
            }
            .tabsDesktop {
                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme,
                        [
                            null,
                            css`
                                display: none; ;
                            `,
                            null,
                            null,
                        ],
                        "max",
                    );
                }}
            }
            div[class^="TabGroupWrapper"] {
                ul {
                    z-index: 0;
                    margin-left: 16px;
                    margin-right: 26px;
                    padding: 0;
                    // margin-bottom: 32px;
                    ${({ theme }) => {
                        return breakpointMediaQueries(
                            theme,
                            [
                                null,
                                css`
                                    position: relative;
                                    z-index: 1;
                                    overflow: unset;
                                    flex-direction: column;
                                    width: 100%;
                                `,
                                null,
                                null,
                            ],
                            "max",
                        );
                    }}
                    li {
                        cursor: pointer;
                        text-align: left;
                        font-size: ${TYPOGRAPHY.size.base};
                        letter-spacing: 0px;
                        text-transform: capitalize;
                        padding: 8px 0px 5px;
                        margin-right: 1rem;
                        border-radius: 40px;
                        padding: 4px 16px;
                        border-bottom: none;
                        outline: 0px !important;
                    }
                    li[aria-selected="true"] {
                        font-weight: bold;
                        color: ${COLORS.primary.dark};
                        outline: none;
                        background: linear-gradient(0deg, rgba(38, 107, 64, 0.08), rgba(38, 107, 64, 0.08)), #ffffff;
                    }
                    li[aria-selected="false"] {
                        border-bottom: none;
                        color: ${COLORS.background.tag};
                    }
                }
                > div > div[class^="TabContent"] {
                    border-bottom: none;
                    border: none;
                    padding: 0px 16px 0px 16px;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                null,
                                css`
                                    padding-left: 0;
                                    padding-right: 0;
                                    .flex-container {
                                        display: block;
                                        .content {
                                            border: 2px solid #bdbbbd;
                                            margin-bottom: 24px;
                                        }
                                        .content.with-background {
                                            border: none;
                                        }
                                    }
                                `,
                                null,
                                null,
                            ],
                            "max",
                        )}
                }
            }
            &.pdp-tabularData {
                background-color: #f4f4f4;
            }
        `,
    },
    hideTab: {
        css: css`
            display: none;
        `,
    },
    titleWeight: {
        css: css`
            span {
                font-weight: 600;
            }
        `,
    },
};
const styles = tabularDataStyles;

interface TabModel {
    showTab: boolean;
    name: string;
    type?: string;
}

type TabGroupModel = TabModel[];

const BCIATabularDataWidget: React.FC<Props> = ({
    fields,
    id,
    isComponentsTabVisible,
    isRecentlyViewedTabVisible,
    isRelatedProductsTabVisible,
    isTopSellerTabVisible,
    handlePDPTabDisplay,
}) => {
    const [tabsData, setTabsData] = useState<{ currentTab: string; tabs: TabGroupModel }>({
        currentTab: "",
        tabs: [],
    });

    const [tabName, setTabName] = useState(tabsData.currentTab);

    useEffect(() => {
        setTabName(tabsData.currentTab);
    }, [tabsData]);

    useEffect(() => {
        if (fields.numberOfTabs.length) {
            const tempTabs: TabModel[] = [];

            let currentTab = "";
            for (let index = 0; index < fields.numberOfTabs.length; index++) {
                const fieldTab = fields.numberOfTabs[index];
                const showTab =
                    fieldTab.fields.type === "components"
                        ? isComponentsTabVisible
                        : fieldTab.fields?.type === "recentlyViewed"
                        ? isRecentlyViewedTabVisible
                        : fieldTab.fields?.type === "relatedProducts"
                        ? isRelatedProductsTabVisible
                        : fieldTab.fields?.type === "topSellers"
                        ? isTopSellerTabVisible
                        : false;
                const selected: boolean =
                    index === 0
                        ? showTab
                        : !!(index > 0 && tempTabs.length > 0 && tempTabs[0].showTab === false && showTab);
                if (selected) {
                    currentTab = fieldTab.fields.name;
                }
                tempTabs.push({
                    showTab,
                    name: fieldTab.fields.name,
                    type: fieldTab.fields.type,
                });
            }
            setTabsData({ ...tabsData, currentTab, tabs: tempTabs });
        }
        return () => {
            setTabsData({ ...tabsData, currentTab: "", tabs: [] });
        };
    }, [isComponentsTabVisible, isRecentlyViewedTabVisible, isRelatedProductsTabVisible, isTopSellerTabVisible]);

    const options = () => {
        if (tabsData) {
            const items = tabsData.tabs.map((i: any) => ({ optionValue: i.name, optionText: i.name }));
            return items;
        }
        return [];
    };

    const handleTabChange = (event: React.MouseEvent | React.KeyboardEvent) => {
        handlePDPTabDisplay({ parentTab: "changeTab", value: false, currentTab: event.currentTarget.id });
    };

    const dropDownChange = (e: any) => {
        handlePDPTabDisplay({ parentTab: "changeTab", value: false, currentTab: e });
        setTabName(e);
    };

    if (tabsData.tabs.length === 0) {
        return null;
    }

    return (
        <StyledWrapper
            {...styles.wrapper}
            {...(tabsData.currentTab === "" && { ...tabularDataStyles.hideTab })}
            className={fields.cssClass}
        >
            {tabsData.tabs.length > 0 && (
                <TabGroup
                    className="tabsDesktop"
                    data-test-selector="tabMobileDropdown"
                    current={tabsData.currentTab}
                    onTabChange={handleTabChange}
                >
                    {tabsData.tabs.map((tab, index) => {
                        const tabStyle = !tab.showTab ? tabularDataStyles.hideTab : "";
                        return (
                            <Tab
                                data-test-selector="tabListData"
                                headline={tab.name}
                                tabKey={tab.name}
                                {...tabStyle}
                                key={tab.name}
                                {...styles.titleWeight}
                            >
                                <Zone contentId={id} zoneName={tab.name}></Zone>
                            </Tab>
                        );
                    })}
                </TabGroup>
            )}
            <Hidden above="sm" as="div" className="tabsMobile">
                <DynamicDropdown selected={tabName} onSelectionChange={dropDownChange} options={options()} />
                {tabsData.tabs.length > 0 &&
                    tabsData.tabs
                        .filter(i => i.name === tabName)
                        .map(tab => {
                            return (
                                <>
                                    <Zone contentId={id} zoneName={tab.name}></Zone>
                                </>
                            );
                        })}
            </Hidden>
        </StyledWrapper>
    );
};

const tabTypeOptions = [
    { value: "components", displayName: "Components" },
    { value: "recentlyViewed", displayName: "Recently Viewed" },
    { value: "relatedProducts", displayName: "Related Products" },
    { value: "topSellers", displayName: "Top Sellers" },
];

const bciaTabularDataWidget: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(BCIATabularDataWidget),
    definition: {
        group: "Common",
        fieldDefinitions: [
            {
                name: fields.numberOfTabs,
                editorTemplate: "ListField",
                getDisplay: (item: HasFields) => {
                    return item.fields.name;
                },
                defaultValue: [],
                fieldType: "General",
                sortOrder: 1,
                fieldDefinitions: [
                    {
                        name: "name",
                        displayName: "Tab Name",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                    {
                        name: "type",
                        displayName: "Tab Type",
                        editorTemplate: "DropDownField",
                        options: tabTypeOptions,
                        defaultValue: "recentlyViewed",
                    },
                ],
            },
            {
                name: fields.cssClass,
                displayName: "Add CSS Class",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "General",
            },
        ],
    },
};
export default bciaTabularDataWidget;
